import React from "react";
import GradientButton from "./buttonUI/GradientButton";
import GrayButton from "./buttonUI/GrayButton";
import Modal from "../portal/Modal";

const Dialog = ({
  messageIcon,
  message,
  confirmBtnText,
  checkAction,
  cancelBtnText,
  closeDialog,
  numbersOfAcceptAndReject,
}) => {
  const getDataCheckCountsObj = JSON.parse(
    localStorage.getItem("dataCheckCounts"),
  );
  const numbersOfAcceptAndRejectObj = getDataCheckCountsObj
    ? getDataCheckCountsObj
    : numbersOfAcceptAndReject;

  return (
    <Modal
      onClose={closeDialog}
      modalWidth="flex-center-align dialogBoxWrap"
      closeIcon={true}
    >
      <div className="px-12 2xs:max-sm:px-0">
        {messageIcon && (
          <img src={messageIcon} alt="messageIcon" className="mx-auto mb-5" />
        )}
        {message && <p className="dialogBoxMsg">{message}</p>}
        {(numbersOfAcceptAndReject || getDataCheckCountsObj) && (
          <>
            <p className="font-figtree pt-4 text-gray-700">
              {numbersOfAcceptAndRejectObj.trueCount} Expenses Selected to
              Accept
            </p>
            <p className="font-figtree text-gray-700">
              {numbersOfAcceptAndRejectObj.falseCount} Expenses Selected to
              Reject
            </p>
          </>
        )}
        {confirmBtnText && cancelBtnText && (
          <div className="flex-center-align sm:mt-10 mt-4 gap-2">
            <GradientButton btnText={confirmBtnText} onClick={checkAction} />
            <GrayButton btnText={cancelBtnText} onClick={closeDialog} />
          </div>
        )}
      </div>
    </Modal>
  );
};

export default Dialog;
